'use client';
import React from 'react';
import { CategoryMetadata as SharedCategoryMetadata } from '@launchstore/shared-puck';
import type { CategoryMetadataProps } from '@launchstore/shared-puck';
import { useCategory } from '@lib/hooks/useCategory';

const SharedCategoryMetadataRender = (SharedCategoryMetadata as any).render;

const CategoryMetadataImpl: React.FC<CategoryMetadataProps> = (props) => {
  const { category } = useCategory() as any;
  return <SharedCategoryMetadataRender {...(props as any)} category={category} />;
};

export const CategoryMetadata: any = { ...SharedCategoryMetadata, render: (props: any) => <CategoryMetadataImpl {...props} /> };
export default CategoryMetadata;
